import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";

/** Markdown link don't have any attributes */
export function TargetBlankPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.getRootElement()?.addEventListener("click", e => {
      const href = (e.target as HTMLElement)?.closest("a")?.getAttribute("href");
      if (href) {
        e.preventDefault();
        window.open(href, "_blank");
      }
    });
  }, [editor]);

  return null;
}
